import "layouts/Home/Home.css";
import React from "react";
import {request} from "../../../api-client";
import ViewContainer from "../../../components/Letflow/ViewContainer/ViewContainer";
import localization from "../../../config/localization";
import {homePathGenerator, setPageTitle} from "../../../api-client/core/authentication/utils";
import HomePlaylistGridItem from "./HomePlaylistGridItem";
import HomeAddButton from "../../../components/Letflow/Button/HomeAddButton";
import analyticsInstance from "../../../analytics/analyticsInstance";
import FormView from "./Form";
import FormViewContainer from "../../../components/Letflow/ViewContainer/FormViewContainer";
import {Dialog, Grid} from "@material-ui/core";
import browserHistory from "../../../utils/browserHistory";
import {getPropertySafe} from "../../../utils";
import ShareOnSocials from "../../../components/Letflow/ShareOnSocials";
import HomeSearchInput from "../../../components/Letflow/HomeSearchInput";
import {List} from "@material-ui/icons";
import GlobalSnackbar, {GlobalSnackbarTypes} from "../../../components/Letflow/Snackbar/GlobalSnackbar";

class HomePlaylists extends React.Component {
  state = {
    playlists: [],
    sharingPlaylist: false,
    playlistToShare: -1,
    playlistId: '',
    title: '',
    subtitle: '',
    userLibrary: '',
    visibility: '',
    disabled: false,
    showPlaylistCreationDialog: false,
    openUpdateDialog: false,
    shareToken: "",
    search: "",
    availablePlaylists: []
  };

  componentDidMount = () => {
    setPageTitle(localization.get('title.playlists'));
    document.getElementsByTagName('html')[0].scrollTop = 0
  };

  requestPlaylistsForClient = () => request.playlist.getAllForHome()
    .then(playlists => this.setState({playlists, availablePlaylists: playlists}));


  renderPlaylistCreationDialog = () => {
    const {title, subtitle, userLibrary, visibility} = this.state;
    return (
      <Dialog open={this.state.showPlaylistCreationDialog} onBackdropClick={() => this.setState({showPlaylistCreationDialog: false})}>
        <FormViewContainer
          title={localization.get('home_playlist.create')}
          onBack={() => this.setState({showPlaylistCreationDialog: false})}
          submitRequest={() => request.playlist.create({
            title,
            subtitle,
            visibility
          })
            .then(() => analyticsInstance.createPlaylist(title))
            .then(() => this.setState({showPlaylistCreationDialog: false}))
            .then(() => this.requestPlaylistsForClient())
            .then(() => this.forceUpdate())
          }
          style={{width: "100%", display: "table"}}
          color="black"
          smallExtraSpace={true}
          actionsExtraSpace={window.innerWidth > 600}
        >
          <FormView
            title={title}
            subtitle={subtitle}
            onChange={e => this.setState({ [e.target.id]: e.target.value })}
            onVisibilityLibraryChange={e => this.setState({ visibility: e })}
            visibility={visibility}
          />
        </FormViewContainer>
      </Dialog>
    )
  };

  onDelete = id => request.playlist.delete(id)
    .then(() => {
      GlobalSnackbar.show({message: localization.get('playlist.deleted'), type: GlobalSnackbarTypes.SUCCESS})
      this.setState({playlists: this.state.playlists.filter(playlist => playlist.id !== id), availablePlaylists: this.state.availablePlaylists.filter(playlist => playlist.id !== id)})
    }).catch(() => GlobalSnackbar.showGenericError())

  onEdit = playlist => this.setState({
    openUpdateDialog: true,
    playlistId: playlist.id,
    title: playlist.title,
    subtitle: playlist.subtitle,
    visibility: playlist.visibility === 'public',
    selectedClientIds: getPropertySafe(playlist, 'clients', []).map(x => x.id)
  });

  makeUpdateDialog = () =>
    <Dialog open={this.state.openUpdateDialog} onBackdropClick={() => this.setState({openUpdateDialog: false})}>
      <FormViewContainer
        title={localization.get('home_playlist.update')}
        onBack={() => this.setState({openUpdateDialog: false})}
        submitRequest={this.requestUpdate}
        onRequestingStateChanged={value => this.setState({ disabled: value })}
        style={{maxWidth: "600px", width: "100%", display: "table"}}
        color="black"
        smallExtraSpace={true}
      >
        <FormView
          title={this.state.title}
          onChange={e => this.setState({ [e.target.id]: e.target.value })}
          disabled={this.state.disabled}
        />
      </FormViewContainer>
    </Dialog>

  requestUpdate = () => {
    const { title, subtitle, visibility, playlistId } = this.state;
    return request.playlist.update({
      playlistId: playlistId,
      title,
      subtitle,
      visibility
    })
      .then(() => this.requestPlaylistsForClient())
      .then(() => this.setState({openUpdateDialog: false}))
  };

  render() {
    const {playlists} = this.state;

    return (
      <ViewContainer
        ref="viewContainer"
        initializationRequest={() => this.requestPlaylistsForClient()}
      >
        <div id="innerinner" className="home-playlists" style={{marginTop: 40}}>
          <HomeAddButton onClick={() => this.setState({showPlaylistCreationDialog: true})}/>
          <div style={{display: 'flex', justifyContent: 'space-between', padding: "10px 50px 0"}}>
            <div className="favorites-section-title">
              <div style={{
                textTransform: 'uppercase',
                display: 'flex',
                alignItems: 'center',
                fontSize: 18,
                fontWeight: 'bold',
                lineHeight: '36px',
                marginBottom: '20px'
              }}><List style={{marginRight: 5, fontSize: 28}}/>{localization.get("navbar.playlists.side")}</div>
            </div>
            <HomeSearchInput
              styles={{marginBottom: 20}}
              value={this.state.search}
              placeholder={"searchbar.playlist"}
              onSearch={value =>
                this.setState({
                  search: value,
                  availablePlaylists: this.state.playlists.filter(i =>
                    i.title.toLowerCase().includes(value.toLowerCase())
                  )
                })
              }
            />
          </div>
          {this.state.availablePlaylists.length > 0 ?
            <section data-max-per-row={4} className="category">
              <ShareOnSocials
                show={this.state.showShareDialog}
                handleClose={() => this.setState({showShareDialog: false, shareToken: ""})}
                url={`${window.location.protocol}//${window.location.hostname}/public/playlists/${this.state.shareToken}`}
                darkMode={true}
                shareToken={this.state.shareToken}
              />
              <Grid spacing={1}  container>
                {this.state.availablePlaylists.map((playlist, key) => {
                  return (
                    <Grid key={key} xs={12} sm={6} md={4} lg={3} xl={2} item>
                      <HomePlaylistGridItem
                        playlist={playlist}
                        onClick={() => browserHistory.push(homePathGenerator(`playlist/${playlist.id}`))}
                        onDelete={(id) => this.onDelete(id)}
                        onEdit={this.onEdit}
                        onShare={() =>
                          request.playlist.share(playlist.id)
                            .then(response => this.setState({
                              showShareDialog: true,
                              shareToken: response.code
                            }))
                      }
                      />
                    </Grid>

                  )
                })}
              </Grid>
            </section>
            :
            <div
              style={{
                float: "left",
                position: "relative",
                width: "100%",
                textAlign: "center",
                marginTop: "50px",
                fontSize: "20px",
                padding: "40px"
              }}
            >{localization.get(!this.state.search ? 'playlists.empty' : 'playlists.not_found')}</div>}
        </div>
        {this.renderPlaylistCreationDialog()}
        {this.makeUpdateDialog()}
      </ViewContainer>
    )
  }
}

export default HomePlaylists;
